export const environment = {
  production: true,
 //url: 'https://demo.qtraq.in/qtraqservices/qtraqapi/'
  url: 'https://uat.qtraq.in/qtraqservices/qtraqapi/'
//live url
//url: 'https://qtraq.in/qtraqservices/qtraqapi/'
};
//url: 'https://demo.qtraq.in/qtraqservices/qtraqapi/'



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts